import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { IsTokenExpired } from '../common/jwtToken'
import Layout from '../layout'

const ProtectedRoute = ({ children, ...rest }) => {
	const location = useLocation()
	const userPermissions = localStorage.getItem('permissions')?.split(',') || []
	const userData = JSON.parse(localStorage.getItem('user') || '{}')
	// console.log(userData,"userData")
	const isAdmin = userData?.adminOfHubs
	// console.log(userPermissions)
	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	if (!hubId && !permissionOfHub && userPermissions.length > 0) {
		return <Navigate to="/" />
	}

	if (!localStorage.getItem('token')) {
		return <Navigate to="/" />
		// <Outlet />;
	}
	if (localStorage.getItem('token')) {
		// console.log("hii")
		return (
			<Layout>
				<Outlet />
			</Layout>
		)
	}
	const currentPath = location.pathname.substring(1)
	// console.log(currentPath)
	// If user is admin, allow access to all routes
	if (isAdmin) {
		return (
			<Layout>
				<Outlet />
			</Layout>
		)
	}
	if (userPermissions && userPermissions.length > 0 && currentPath) {
		// if (currentPath === "dashboard") {
		//   return (
		//     <Layout>
		//       <Outlet />
		//     </Layout>
		//   );
		// }
		// Check if the current path starts with any of the user's permissions
		if (userPermissions.some(permission => currentPath.startsWith(permission))) {
			return (
				<Layout>
					<Outlet />
				</Layout>
			)
		}
		return <Navigate to={`/${userPermissions[0]}`} />
	}
	// Default case: redirect to login
	return <Navigate to="/" />
}

export default ProtectedRoute
